import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-rotate",
  templateUrl: "./med-icon-rotate.component.html",
})
export class MedIconRotateComponent extends SvgMixinComponent {}
